export const PICK_VIEWS = {
    ROUTE_VIEW : "Route View",
    WORKSTATION_VIEW : "Pick station View",
    LAYOUT_GRID_VIEW : "Layout Grid View",
}

export const WORKSTATION_METRIC_SPANS = {
    min15 : "15m",
    min30 : "30m",
    hour1 : "1h",
    cumulative : "CUMULATIVE",
    none : "NONE"
}

export const WORKSTATION_METRIC_TYPES = {
    STRING : "STRING",
    DOUBLE : "DOUBLE",
    DEFAULT : "DEFAULT"
}

/* Picklist Status received from Backend */
export const PICKLIST_ASSIGNABLE = "ASSIGNABLE";
export const PICKLIST_IN_PROGRESS = "IN_PROGRESS";
export const PICKLIST_ASSIGNED = "ASSIGNED";
export const PICKLIST_LOCKED = "LOCKED";

export const AVAILABLE = "AVAILABLE";
export const BLOCKED = "BLOCKED";
export const OVERCROWDED = "OVERCROWDED";

export const MANUAL_ASSIGNMENT = "MANUAL_ASSIGNMENT";
export const MANUALLY_PRIORITISED = "MANUALLY_PRIORITISED";
export const OPTIMAL = "OPTIMAL";
export const TIME_CRITICAL = "TIME_CRITICAL";





// WEBPACK FOOTER //
// ./src/components/pickStatus/constants/Constants.js